export default "__VITE_ASSET__CgjeGm9D__"